export default __webpack_public_path__ + "static/media/download.f43f223a.svg";